<script>
export default {
    name: "ReverseTest",

    props: {
        showModal: Boolean,
        test: {
            type: Object,
            required: true,
        },
    },

    methods: {

        saveReverseTest() {
            if(!window.confirm(`Confirm Reverse Test`)) return;

            this.$root.loading = true;

            const reverseTest = {
                investigationID: this.test.patientLabResultId,
                done: false,
                comment: ``,
                userName: this.$root.username,
            };

            this.$http.post(`Lab/ChangeInvestigationState`, reverseTest).then(() => {
                this.$emit(`refresh`);
                this.$root.loading = false;
                this.$emit(`closeModal`);
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/4 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Reverse Test</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full p-1">
            <h5 class="font-medium text-sm">{{ test.test }}</h5>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs mr-6" 
        @click.prevent="$emit(`closeModal`)">
            Close</button>
    <button 
        @click.prevent="saveReverseTest()"
        class="btn-primary btn-sm text-xs">
            Save Reverse</button>
  </template>
</tail-modal>
</template>
